(() => {
  const root = document.documentElement;
  const pick = () => document.querySelector('#main-nav .sp-mega__feature');
  const publish = (el) => {
    const w = el ? el.getBoundingClientRect().width : 0;
    if (w > 0) root.style.setProperty('--sp-mega-feature-w', w + 'px');
    else root.style.removeProperty('--sp-mega-feature-w');
  };
  const start = () => {
    const el = pick();
    publish(el);
    if (!el || !('ResizeObserver' in window)) {
      window.addEventListener('resize', () => publish(pick()));
      return;
    }
    new ResizeObserver(() => publish(el)).observe(el);
    window.addEventListener('resize', () => publish(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
